import React from "react";
import Hero from "../../components/pages/About/Hero/Hero";
import "./About.css";
import WhatWeDo from "../../components/pages/About/WhatWeDo/WhatWeDo";
import OurValues from "../../components/pages/About/OurValues/OurValues";
import Help from "../../components/pages/About/Help/Help";

const About = () => {
  return (
    <div className="about-page">
      <div className="about-page__grid-section">
        <Hero />
      </div>
      <WhatWeDo/>
      <OurValues/>
      <Help/>
    </div>
  );
};

export default About;
